import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import { shouldRedirectWeb } from 'lib/riskbase';
import * as React from 'react';
import { ImageBackground } from 'react-native';
import { selectHasAuthToken } from 'store/auth/selectors';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ROOT],
  Screens.ROOT_AUTH
>;

const AssetBackdropJpeg = require('assets/backdrop.jpg');

export const AuthScreen: React.FC<Props> = ({ navigation }) => {
  const hasAuthorizationToken = useSelector(selectHasAuthToken);
  React.useEffect(() => {
    if (hasAuthorizationToken) {
      navigation.replace(Screens.ROOT_TAB, {
        screen: Screens.TAB_OFFLINE,
        params: {
          screen: Screens.OFFLINE_ASSETS,
        },
      });
    } else {
      const redirectTo = shouldRedirectWeb();
      if (redirectTo) {
        window.location.replace(redirectTo);
      }
    }
  }, [navigation, hasAuthorizationToken]);

  return (
    <ImageBackground
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        opacity: 0.2,
      }}
      imageStyle={{ resizeMode: 'cover' }}
      source={AssetBackdropJpeg}
    />
  );
};
